import { useRef } from "react"
import RichText from "@components/rich-text/renderer"
import { MikanSpan } from "@components/Mikan"

const VideoWithTimeline = ({ content: { pageContent, heroID, titleID, titlesID, timestampsID, videoID, vimeoID } }) => {
  const player = useRef(null)

  const hero = pageContent[heroID]
  const sections_title = pageContent[titleID].text
  const section_titles = pageContent[titlesID]
  const section_timestamps = pageContent[timestampsID]
  const video = pageContent[videoID]

  const sectionData = section_titles.items.map(({ text }, index) => {
    return [text, section_timestamps.items[index].text]
  })

  const handleSectionSelected = (e, timestamp) => {
    e.preventDefault()
    player.current.contentWindow.postMessage({ method: "seekTo", value: Number(timestamp) }, "*")
    player.current.contentWindow.postMessage({ method: "play" }, "*")
  }

  const getTimestampedHref = (t) => {
    if (video) {
      const url = new URL(video.embedUrl.url)
      url.hash = `t=${t}s`
      url.searchParams.set("autoplay", "1")
      return url.toString()
    }
    return `https://vimeo.com/${vimeoID}#t=${t}s?autoplay=1`
  }

  const getVideoSrc = () => {
    if (video) {
      const url = new URL(video.embedUrl.url)
      url.searchParams.set("color", "e82c2a")
      return url.toString()
    }
    return `https://player.vimeo.com/video/${vimeoID}?h=fd1bf79643&color=e82c2a`
  }

  return (
    <div>
      <section id="navigating-success-hero">
        <div className="row">
          <div className="column">
            <RichText body={hero.rtContent} mikan={hero.mikan} />
          </div>
        </div>
      </section>
      <section id="navigating-video-sections">
        <div className="row">
          <div className="video-playlist">
            <nav className="vertical-nav">
              <h2>
                <MikanSpan text={sections_title} />
              </h2>
              {sectionData.map((value) => (
                <p key={value[1]}>
                  <a href={getTimestampedHref(value[1])} onClick={(e) => handleSectionSelected(e, value[1])}>
                    {value[0]}
                  </a>
                </p>
              ))}
            </nav>
            <div className="video">
              <div className="embed-responsive">
                <iframe
                  title="Navigating with success"
                  ref={player}
                  src={getVideoSrc()}
                  className="embed-responsive-item"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default VideoWithTimeline
